import { useTranslation } from 'react-i18next';
import { Stack, Typography, useTheme } from '@mui/material';
import { LockedIllustration, FixedHeadersSpacer, useFixedHeader } from '@diana/core';
import { FLOW_BUILDER2_PAGE_NS } from '../../i18n';
import { isDesktop } from 'react-device-detect';

export const DesktopOnlyErrorView = () => {
  const { t } = useTranslation(FLOW_BUILDER2_PAGE_NS);
  const { headerOffset } = useFixedHeader();
  const { palette, zIndex } = useTheme();

  return (
    <>
      <FixedHeadersSpacer />
      <Stack
        alignItems="center"
        justifyContent="center"
        minHeight={`calc(100vh - ${headerOffset}px)`}
        px={2}
        position="relative"
        zIndex={zIndex.drawer}
        bgcolor={palette.background.paper}
      >
        <LockedIllustration />
        <Stack pt={4} gap={0.25} textAlign="center">
          <Typography variant="h5" fontSize={16}>
            {isDesktop ? t('titles.browserSmall') : t('titles.screenSmall')}
          </Typography>
          <Typography color="text.secondary">
            {isDesktop ? t('descriptions.resizeBrowser') : t('descriptions.useDesktopDevice')}
          </Typography>
        </Stack>
      </Stack>
    </>
  );
};
